<template>
    <b-modal
        title-tag="h2"
        title="Email Attachment"
        lazy
        :visible="isOpen"
        no-enforce-focus
    >
        <form>
            <b-form-group label-cols="2" label="To:" label-for="to">
                <!-- do not change the module of vet select: logic handling issue -->
                <recipient-email
                    name="recipient"
                    v-model="recipient"
                    multiple
                    placeholder="Client or Contact Email (required)"
                    @input="handleRecipientChange"
                    :key="recipientComponentKey"
                    :client="clientDetails"
                />
            </b-form-group>

            <b-form-group label-cols="2" label="Subject:" label-for="subject">
                <b-form-input
                    v-model="subject"
                    :placeholder="
                        isLoadingEmailDefaultLetter
                            ? 'Loading...'
                            : 'Subject (optional)'
                    "
                />
            </b-form-group>

            <b-form-group label-cols="2" label="Message:" label-for="message">
                <tinymce
                    :init="tinymceConfig"
                    v-model="message"
                    @onKeyPress="contentChanged"
                />
            </b-form-group>

            <b-form-group
                label-cols="2"
                label="Attachment:"
                label-for="attachment"
            >
                <p class="m-2">{{ attachmentTitle }}</p>
            </b-form-group>
        </form>

        <template v-slot:modal-footer>
            <loader v-if="isSending" class="m-0" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSending"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSending" variant="primary" @click="send">
                Send
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ClientDocumentService from "@/services/client-documents";
import Loader from "@/module/commons/loader";
import tinymce from "@tinymce/tinymce-vue";
import tinymceHelper from "@/module/commons/helper-tinymce"; // helper
import recipientEmail from "@/components/commons/recipients-email";

export default {
    components: {
        Loader,
        tinymce,
        recipientEmail
    },
    data() {
        return {
            isOpen: false,
            attachmentId: null,
            recipient: [],
            subject: "",
            message: "",
            isLoading: true,
            isSending: false,
            isLoadingEmailDefaultLetter: true,
            clientDetails: null,
            recipientComponentKey: 0,
            emailDefaultLetter: {
                body: null,
                subject: null
            },
            tinymceConfig: {
                ...tinymceHelper.core, // use spread operator to inject all vetter-related configs
                toolbar: false,
                plugins: tinymceHelper.plugins
            },
            isContentChanged: false,
            attachmentTitle: null,
            record: null
        };
    },
    methods: {
        contentChanged() {
            // detect content has been changed by user (once)
            if (!this.isContentChanged) {
                this.isContentChanged = true;
            }
            return true;
        },
        async open(record) {
            this.isOpen = true;
            this.attachmentId = record.id;
            this.setEmailDefaultContent();
            this.setDefaultRecipient(record.recipient);
            this.attachmentTitle = record.title;
            this.record = record;
        },
        close() {
            this.isOpen = false;
        },
        setDefaultRecipient(recipient = null) {
            if (recipient) {
                recipient.recipient_is_client = true;
            }

            this.clientDetails = recipient;
            this.recipientComponentKey++; // force re-render
        },
        constructActorIds(recipients = []) {
            let ids = [];

            for (const recipient of recipients) {
                ids.push(recipient.to_id);
            }

            return ids;
        },
        async send() {
            const firstRecipient = this.recipient[0];

            if (!firstRecipient || this.message === "") {
                return;
            }

            this.isSending = true;

            const response = await ClientDocumentService.emailAttachment({
                attachmentId: this.attachmentId,
                to: this.constructActorIds(this.recipient),
                subject: this.subject,
                message: this.message
            });

            this.isSending = false;

            if (response.code === 200) {
                this.close();
                this._message("Attachment emailed");
            } else {
                this._message(response.message, "danger");
            }
        },
        setEmailDefaultContent() {
            let clinicName =
                this._setting && this._setting.business
                    ? this._setting.business.name
                    : null;
            let subject = "Attachment from " + clinicName;
            let message =
                "<p>Dear {RECIPIENT_FIRST_NAME},</p>\n<p>Below is a link to your attachment.</p>\n";
            message += "<p>Thank you,</p>";
            message += clinicName;

            this.emailDefaultLetter = {
                body: message,
                subject: subject
            };

            this.isLoadingEmailDefaultLetter = false;
            this.subject = subject;
            this.message = message;
        },
        async handleRecipientChange(values = []) {
            if (values.length === 0 && !this.isContentChanged) {
                this.message = this.emailDefaultLetter.body;
            } else {
                let recipients = [];
                let ids = [];
                for (const rec of values) {
                    if (ids.includes(rec.oriId)) {
                        continue;
                    }
                    recipients.push(rec.firstname);
                    ids.push(rec.oriId);
                }

                let firstNames = recipients.join(" ,");
                let msg = this.message || "";
                let header = msg.slice(0, msg.indexOf("</p>"));
                let body = msg.substring(msg.length, header.length + 4);
                body = "<p>Dear " + firstNames + ",</p>\n" + body;

                this.message = body;
            }
        }
    }
};
</script>
